// import React, { useState } from "react";
// import { LocalizationProvider } from "@fluent/react";
// import { FavoriteButton } from "./FavoriteButton";
declare var React: any, FavoriteButton: any

export function FavoriteSelection(props) {
    let LocalizationProvider = window["FluentReact"].LocalizationProvider;

    return <LocalizationProvider l10n={props.l10n}>

        <div className="dropdown-select favorite-book-select">

            <div className="dropdown-select-header">
                <FavoriteButton buttonTextId={props.buttonTextId} />
            </div>

            <div className="dropdown-select-body favorite-book-select-body">
            </div>

        </div>

    </LocalizationProvider>;
}
